import React from "react";
import PropTypes from "prop-types";
import { get, omit } from "lodash";
import Checkbox from "./CustomCheckbox";

const CheckboxInput = ({
  field: { name, ...field },
  form: { touched, errors, setFieldValue },
  label,
  number
}) => {
  const error = get(errors, name, null);
  const touch = get(touched, name, false);

  const onCheck = ev => {
    setFieldValue(name, ev.target.checked);
  };

  return (
    <Checkbox
      error={touch && error}
      label={label}
      number={number}
      {...{
        name,
        error: touch && error,
        ...omit(field, "value"),
        defaultChecked: field.value
      }}
      onChange={onCheck}
    />
  );
};

CheckboxInput.propTypes = {
  field: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
  label: PropTypes.string
};

export default CheckboxInput;
